module.exports = __webpack_public_path__ + "img/copiar.235c0a6f.svg";